/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SubscribeRequirements } from './SubscribeRequirements';
import {
    SubscribeRequirementsFromJSON,
    SubscribeRequirementsFromJSONTyped,
    SubscribeRequirementsToJSON,
} from './SubscribeRequirements';
import type { Support } from './Support';
import {
    SupportFromJSON,
    SupportFromJSONTyped,
    SupportToJSON,
} from './Support';

/**
 * 
 * @export
 * @interface ModuleInfo
 */
export interface ModuleInfo {
    /**
     * 
     * @type {string}
     * @memberof ModuleInfo
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof ModuleInfo
     */
    baseURL: string;
    /**
     * 
     * @type {Support}
     * @memberof ModuleInfo
     */
    support: Support;
    /**
     * 
     * @type {SubscribeRequirements}
     * @memberof ModuleInfo
     */
    subscribeRequirements?: SubscribeRequirements;
}

/**
 * Check if a given object implements the ModuleInfo interface.
 */
export function instanceOfModuleInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "displayName" in value;
    isInstance = isInstance && "baseURL" in value;
    isInstance = isInstance && "support" in value;

    return isInstance;
}

export function ModuleInfoFromJSON(json: any): ModuleInfo {
    return ModuleInfoFromJSONTyped(json, false);
}

export function ModuleInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModuleInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayName': json['displayName'],
        'baseURL': json['baseURL'],
        'support': SupportFromJSON(json['support']),
        'subscribeRequirements': !exists(json, 'subscribeRequirements') ? undefined : SubscribeRequirementsFromJSON(json['subscribeRequirements']),
    };
}

export function ModuleInfoToJSON(value?: ModuleInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayName': value.displayName,
        'baseURL': value.baseURL,
        'support': SupportToJSON(value.support),
        'subscribeRequirements': SubscribeRequirementsToJSON(value.subscribeRequirements),
    };
}

